import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getContractTypesAction } from "../actions";
import { getLoading, getData, getTypes } from "../selectors";
import { getAppColor } from "@icarius-app/selectors";
import { getLocalizedString } from "@icarius-localization/strings";
import { Grid } from "@material-ui/core";
import DataItem from "./data/dataItem";
import { RESET_STATE } from "../actionTypes";
import ABMLayout from "@icarius-common/abmComponents/abmLayout";
import paths from "@icarius-router/paths";

const ContractTypesSettings = ({ history }) => {
    const [createIsOpen, setCreateIsOpen] = useState(false);

    const dispatch = useDispatch();

    const color = useSelector(getAppColor);
    const data = useSelector(getData);
    const types = useSelector(getTypes);
    const isLoading = useSelector(getLoading);

    useEffect(() => {
        dispatch(getContractTypesAction());
        return () => {
            dispatch({ type: RESET_STATE });
        };
    }, [dispatch]);

    const getDataIsEmpty = () => {
        return !data || data.length === 0;
    };

    const handleGoBack = () => {
        history.push(paths.entryExitTypes);
    };

    return (
        <ABMLayout
            title={getLocalizedString("contractTypesSettings")}
            isLoading={isLoading}
            showCreateButton={!createIsOpen}
            createButtonTitle={getLocalizedString("newContractType")}
            createButtonOnClick={() => setCreateIsOpen(true)}
            showNoData={getDataIsEmpty()}
            noDataTitle={getLocalizedString("noContractTypes")}
            noDataCreateTitle={getLocalizedString("newContractType")}
            noDataOnClick={() => setCreateIsOpen(true)}
            showGoBack
            handleGoBack={handleGoBack}
        >
            {createIsOpen && (
                <Grid container item xs={12} style={{ margin: "10px 0px" }}>
                    <DataItem color={color} data={null} types={types} closeNew={() => setCreateIsOpen(false)} />
                </Grid>
            )}
            {data &&
                data.map((item) => {
                    return (
                        <Grid container item xs={12} style={{ margin: "10px 0px" }} key={item.internalCode}>
                            <DataItem data={item} types={types} color={color} />
                        </Grid>
                    );
                })}
        </ABMLayout>
    );
};

export default ContractTypesSettings;
